'use strict';

// define jquery (note: keep this in a seperate file, otherwise vendor modules may cause "jQuery undefined" error!
// (see https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import)
import './imports/jquery';

// import vendor plug-ins
import 'bootstrap/dist/js/bootstrap.bundle'; /* Includes popper.js, import 'bootstrap' does not include popper.js */
import 'bootstrap4-toggle';
import 'dropify';
import TypeIt from 'typeit';
import moment from 'moment';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/autocomplete';
import 'datatables.net';
import 'datatables.net-bs';
import 'sortablejs';
import 'jquery-countto';
import 'jquery-infinite-scroll-helper';
import 'multiselect';
import 'bootstrap-colorpicker';

// import quill editor plug-ins
import Quill from 'quill/core';

// define 'iris' namespace
if (!('iris' in window)) window['iris'] = {};

// define plugs-ins in global scope
window.moment = moment;
window.Quill = Quill;
window.TypeIt = TypeIt;

// see https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

/************************
 * Global onload events *
 ************************/
$(document).ajaxComplete(function (event) {
    iris.onloadEvents();
});

$(function () {
    iris.onloadEvents();
});